import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isString } from 'lodash';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import { popApplicationMessage } from '@actions/messages-actions';

const InfoSnackbar = () => {
  const dispatch = useDispatch();
  const messages = useSelector(state => state.messages);

  const popMessage = useCallback(() => {
    dispatch(popApplicationMessage());
  }, [dispatch]);

  const snackbarProps = useMemo(() => {
    const isOpen = messages.length > 0;
    const messageData = messages[0] || '';
    let props = {
      open: isOpen,
      autoHideDuration: 5000,
      onClose: popMessage,
      anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      style: { bottom: 0 }
    };

    if (isString(messageData)) {
      props.message = messageData;
    } else {
      const { action, onActionTouchTap, message, ...rest } = messageData;
      props = { ...props, ...rest, message };
      // Convert v0.19 action/onActionTouchTap to v4 action button
      if (action && onActionTouchTap) {
        props.action = (
          <Button color="secondary" size="small" onClick={onActionTouchTap}>
            {action}
          </Button>
        );
      }
    }

    return props;
  }, [messages, popMessage]);

  return <Snackbar {...snackbarProps} />;
};

export default InfoSnackbar;
